import { ofType } from 'redux-observable';
import { mergeMap, exhaustMap } from 'rxjs/operators';

import {
    createPaymentPlanSuccess,
    createPaymentPlanErrors,
} from '@perpay-web/fintech/actions/entities/paymentPlans';
import { BACKEND_CREATE_PAYMENT_PLAN } from '@perpay-web/fintech/constants/actionTypes';
import { PAYMENT_PLANS_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { handleErrorMessageWithFallback } from '@perpay-web/observable/operators/handleErrorMessageWithFallback';

export function createPaymentPlan(action$, state$, { post }) {
    return action$.pipe(
        ofType(BACKEND_CREATE_PAYMENT_PLAN),
        exhaustMap((action) => post(PAYMENT_PLANS_ENDPOINT, action.payload)),
        mergeMap(() => [createPaymentPlanSuccess()]),
        handleErrorMessageWithFallback((error) => [
            createPaymentPlanErrors(error),
        ]),
    );
}
